import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { GlobalContext, UserContext } from 'components/context'
import DocumentSignModal from './DocumentSignModal'

const Documents = ({ membership }) => {
  const { t } = useContext(GlobalContext)
  const { get } = React.useContext(UserContext)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedDoc, setSelectedDoc] = useState(null)

  const documents = membership.documents
  let hasUnsigned = false
  let hasSigned = false

  if (documents.some(e => e.status === 'pending')) {
    hasUnsigned = true
  }
  if (documents.some(e => e.status === 'signed')) {
    hasSigned = true
  }

  const handleSign = (e, doc) => {
    setSelectedDoc(doc)
    setIsModalOpen(true)
  }

  const handleView = async (e, doc) => {
    const newTab = window.open('', '_blank')
    if (!newTab) {
      alert(t('pages.documents.popup'))
      return
    }
    newTab.document.write('<p>Loading document...</p>')

    try {
      const fetchUrl = `/v1/membership/documents/${doc.id}/url`

      const res = await get(fetchUrl)

      if (!res.url) {
        throw new Error(t('pages.documents.not_found'), res)
      }

      newTab.location.href = res.url
    } catch (err) {
      if (newTab) newTab.close()
      console.error(err)
      alert(t('pages.documents.error'))
    }
  }

  const closeModal = (signed) => {
    if (!signed) {
      alert(t('pages.documents.unsigned'))
    }
    setSelectedDoc(null)
    setIsModalOpen(false)
  }

  const signLink = (t, doc) => {
    return (<Link to='#' onClick={(e) => handleSign(e, doc)}>{t('pages.documents.sign')}</Link>)
  }

  const viewLink = (t, doc) => {
    return (<Link to='#' onClick={(e) => handleView(e, doc)}>{t('pages.documents.view')}</Link>)
  }

  const renderList = (documents, status) => {
    return (
      <div>
        <p>{ t(`pages.documents.description.${status}`) }</p>
        {documents.map((doc, i) => {
          return doc.status !== status ? null : (
            <li className='file' key={`doc-${i}`}> {/* eslint-disable-line react/jsx-curly-brace-presence */}
              {doc.name}&nbsp;&nbsp;
              {doc.status === 'signed' ? viewLink(t, doc) : signLink(t, doc)}
            </li>
          )
        })}
      </div>
    )
  }

  return (
    <div id='documents'>
      <h2>{ t('pages.documents.title') }</h2>
      { hasUnsigned && renderList(documents, 'pending')}
      { hasSigned && renderList(documents, 'signed')}
      {isModalOpen && selectedDoc && (
        <DocumentSignModal
          doc={selectedDoc}
          membership={membership}
          onClose={closeModal}
        />
      )}
    </div>
  )
}

Documents.propTypes = {
  membership: PropTypes.object,
}

export default Documents
